$(function() {
    $('.click-to-go').on('click', function() {
        document.location.href = $(this).data('href');
    });
});
